<template>  
  <label
    class="radio-input"
    v-on:click="$emit('handleClick')"
  >
    <div class="radio-input--box">
      <input
        type="radio" 
        :name="name" 
        :value="placeholder" 
        :checked="checked"      
      >
      <span>{{ placeholder }}</span>
    </div>
    
    <slot/>
  </label>
</template>

<script>
  export default {
    name: 'RadioInput',
    props: [
      'placeholder',
      'name',
      'checked'
    ]
  }
</script>

<style lang="scss">
  .radio-input {
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &:last-child {
      margin-bottom: 15px;
    }

    &--box {
      display: flex;
    }

    span {
      margin-left: 10px;
      margin-top: 1px;
      margin-bottom: 0;
    }

    img {
      height: 22px;
    }
  }
</style>